import React, { useContext } from 'react';

import { CMSContext } from '@swf/cms';
import type { ProspectHomepageSlide } from '@swf/cms';
import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import type { ItemBlock } from '@swf/generated/cms/types/Carousel';

import ColumnLayout from './ColumnLayout/ColumnLayout';
import styles from './ProspectHomepageCarousel.scss';
import SliderLayout from './SliderLayout/SliderLayout';

interface Props {
  autoRotate: boolean;
  slides: ItemBlock[];
  slideSpeed: number;
}

const minNumberOfSlides = 2;

const ProspectHomepageCarousel: React.FC<Props> = ({ autoRotate, slides, slideSpeed }) => {
  const cmsContext = useContext(CMSContext);
  const sportsNonAuth = useFeature(FeatureFlag.SportsNonAuth);
  const casinoNonAuth = useFeature(FeatureFlag.CasinoNonAuth);

  if (slides.length < minNumberOfSlides) {
    return null;
  }

  const displayVertical = (vertical: string | null) => {
    switch (vertical) {
      case 'Casino':
        return casinoNonAuth;
      case 'Sports':
        return sportsNonAuth;
      default:
        return true;
    }
  };

  const slidesData = slides
    .filter((slide) => displayVertical(slide.item.vertical))
    .map((slide) => cmsContext[slide.item.reference[0].uid] as ProspectHomepageSlide);

  return (
    <section className={styles.wrapper}>
      <SliderLayout autoRotate={autoRotate} slides={slidesData} slideSpeed={slideSpeed} />
      <ColumnLayout slides={slidesData} />
    </section>
  );
};

export default ProspectHomepageCarousel;
